import React from "react";
import routeGuard from "src/HOC/routeGuard";
import EngineComponentList, {
} from "src/components/EngineComponent/list";
import { RESOURCE_TYPE } from "src/constant/common";

const EngineComponent = () => {

  return (
    <EngineComponentList
    />
  );
};

export default routeGuard(EngineComponent, RESOURCE_TYPE.LABOR_SAVING);